import React from 'react'
import { Col } from 'reactstrap'
import { css } from 'emotion';
import { isMobile, isTablet } from "react-device-detect"

const OfferTiles = (props) => {
    const renderContent = (content) => {
        return { __html: content };
    }

    return props.toggle.map((offerTile, i) => {
        return <Col key={offerTile.offersTileTitle} className={(!isMobile && !isTablet) ? 'offers-hover' : '' + ' position-relative'}>
            <a className='offer-tile-anchor d-block' href={offerTile.tileLink} id={'offer phone ' + (props.id == 1 ? (i + 1) : (i + 4))} >
                {
                    offerTile.eirOffersRoundel.roundelTitle !== '' &&
                    <div className={css`background-color: ${offerTile.eirOffersRoundel.backgroundColor};` + ' roundel offers-roundel d-flex flex-column align-items-center justify-content-center position-absolute'} dangerouslySetInnerHTML={renderContent(offerTile.eirOffersRoundel.roundelTitle)}></div>
                }
                <div className='d-flex flex-column align-items-center justify-content-center'>
                    <img className={(isMobile && !isTablet ? ' mobile-width' : '') + ' offers-image w-100 h-auto'} alt={offerTile.altText} title={offerTile.imageTitle} src={offerTile.offersImage.path} />
                    <div dangerouslySetInnerHTML={renderContent(offerTile.offersTileTitle)}></div>
                    <div className='offer-description' dangerouslySetInnerHTML={renderContent(offerTile.offersTileSubtitle)}></div>
                </div>
            </a>
        </Col>
    })
}

export default OfferTiles
